import { APICore } from "./apiCore";

const api = new APICore();

async function getSearch(queryString = "") {
  return api.get(`/search${queryString}`);
}

export { getSearch };
